// Core Supplements — Theme JS

// Mobile nav toggle
function toggleMobileNav() {
  var nav = document.getElementById('mobileNav');
  nav.classList.toggle('open');
}

// Add to cart (quick add from product cards)
function addToCart(variantId, qty) {
  qty = qty || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    showCartNotification();
    updateCartCount();
  })
  .catch(function(err) { console.error('Add to cart error:', err); });
}

// Cart notification
function showCartNotification() {
  var el = document.createElement('div');
  el.style.cssText = 'position:fixed;bottom:24px;right:24px;background:#0F0F0E;color:white;padding:14px 20px;border-radius:8px;font-size:0.9rem;z-index:999;display:flex;align-items:center;gap:10px;box-shadow:0 4px 20px rgba(0,0,0,0.2);';
  el.innerHTML = '<span style="color:#22C55E;">✓</span> Added to cart';
  document.body.appendChild(el);
  setTimeout(function() { el.remove(); }, 2500);
}

// Update cart count in header
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badge = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          document.querySelector('.cart-icon').appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    });
}

// Collection filter chips
function filterProducts(type, btn) {
  document.querySelectorAll('.filter-chip').forEach(function(c) { c.classList.remove('active'); });
  btn.classList.add('active');
  document.querySelectorAll('.product-card').forEach(function(card) {
    if (type === 'all' || card.dataset.type === type) {
      card.style.display = '';
    } else {
      card.style.display = 'none';
    }
  });
}

// Close mobile nav on outside click
document.addEventListener('click', function(e) {
  var nav = document.getElementById('mobileNav');
  var btn = document.querySelector('.mobile-menu-btn');
  if (nav && nav.classList.contains('open') && !nav.contains(e.target) && !btn.contains(e.target)) {
    nav.classList.remove('open');
  }
});
